export default __webpack_public_path__ + "assets/marker-pin2.8f879931.svg";